import { cn } from '../../../lib/utils';

export type StatusTone = 'ok' | 'warn' | 'bad' | 'neutral';

const TONES: Record<StatusTone, string> = {
  ok: 'bg-green-50 text-green-800',
  warn: 'bg-amber-50 text-amber-800',
  bad: 'bg-red-50 text-red-800',
  neutral:
    'border border-[#00000014] bg-prompt-safecomwhite text-prompt-safecomabbey',
};

export function StatusPill({
  tone = 'neutral',
  dot = true,
  children,
}: {
  tone?: StatusTone;
  dot?: boolean;
  children: React.ReactNode;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium',
        TONES[tone],
      )}
    >
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}
